import React from "react";
import { Menu } from "lucide-react";
import { NeonLogo } from "@/components/reelflo/NeonLogo";

// Mobile top bar contents: the wordmark and one drawer trigger — nothing
// else. The three destinations and the rightSlot are owned by AppShell.
export const AppHeader = ({ onLogoClick, onMenuClick }) => {
    return (
        <div data-testid="app-header" className="flex min-w-0 items-center gap-1">
            <button
                type="button"
                data-testid="app-drawer-trigger"
                aria-label="Open navigation"
                onClick={onMenuClick}
                className="inline-flex h-11 w-11 flex-none items-center justify-center rounded-lg text-white/70 transition-colors duration-200 hover:bg-white/[0.06] hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-400/60"
            >
                <Menu className="h-5 w-5" />
            </button>
            <NeonLogo onClick={onLogoClick} className="text-xl sm:text-2xl" />
        </div>
    );
};
